var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXmarkSolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.685 2.39091C14.2316 1.84429 14.2316 0.956583 13.685 0.409964C13.1384 -0.136655 12.2507 -0.136655 11.7041 0.409964L7.09936 5.01905L2.49028 0.414337C1.94366 -0.132282 1.05595 -0.132282 0.509329 0.414337C-0.0372895 0.960956 -0.0372895 1.84866 0.509329 2.39528L5.11842 7L0.513702 11.6091C-0.0329164 12.1557 -0.0329164 13.0434 0.513702 13.59C1.06032 14.1367 1.94803 14.1367 2.49465 13.59L7.09936 8.98095L11.7085 13.5857C12.2551 14.1323 13.1428 14.1323 13.6894 13.5857C14.236 13.039 14.236 12.1513 13.6894 11.6047L9.08031 7L13.685 2.39091Z",
    fill: "#B2B2B2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXmarkSolid);
export default __webpack_public_path__ + "static/media/xmark-solid.b5e24bcce7446ed15da8c98047d9c032.svg";
export { ForwardRef as ReactComponent };